export const button = {
  background: {
    disabled: 'var(--color-gray-200)'
  },
  border: {
    _: '1px solid transparent',
    disabled: 'var(--color-gray-200)',
    radius: 'var(--border-radius-base)'
  },
  color: {
    disabled: 'var(--color-gray-500)'
  },
  font: {
    size: 'var(--font-size-base)',
    weight: 'var(--font-weight-base)'
  },
  margin: 0,
  padding: 'calc(var(--padding-base) + 2px) var(--padding-large)',
  height: '42px',
  min: {
    width: '50px'
  },

  primary: {
    background: {
      _: 'var(--color-blue-400)',
      active: '#0360b4',
      hover: '#017eed'
    },
    border: {
      _: 'var(--color-blue-400)',
      active: '#0360b4',
      hover: '#017eed'
    },
    color: {
      _: 'var(--color-white)',
      active: 'var(--button-primary-color)',
      hover: 'var(--button-primary-color)'
    }
  },

  secondary: {
    background: {
      _: 'var(--color-gray-100)',
      active: '#e2e1e3',
      hover: '#e2e1e3'
    },
    border: {
      _: 'var(--color-gray-100)',
      active: '#e2e1e3',
      hover: '#c9ccd3'
    },
    color: {
      _: 'var(--color-gray-800)',
      active: 'var(--button-secondary-color)',
      hover: 'var(--button-secondary-color)'
    }
  },

  outline: {
    background: {
      _: 'transparent',
      active: '#e2e1e3',
      hover: 'transparent'
    },
    border: {
      _: 'var(--color-gray-900)',
      active: 'var(--color-gray-800)',
      hover: 'var(--color-gray-600)'
    },
    color: {
      _: 'var(--color-gray-900)',
      active: 'var(--color-gray-800)',
      hover: 'var(--color-gray-600)'
    }
  },

  link: {
    background: {
      _: 'transparent',
      active: 'var(--color-gray-300)',
      hover: 'var(--color-gray-100)'
    },
    border: {
      _: 'transparent',
      active: 'var(--color-gray-300)',
      hover: 'var(--color-gray-100)'
    },
    color: {
      _: 'var(--link-color)',
      active: 'var(--link-color-active)',
      hover: 'var(--link-color)'
    }
  },

  success: {
    background: {
      _: 'var(--color-green-400)',
      active: '#04a83f',
      hover: '#06bc48'
    },
    border: {
      _: 'var(--color-green-400)',
      active: '#04a83f',
      hover: '#06bc48'
    },
    color: {
      _: 'var(--color-white)',
      active: 'var(--button-success-color)',
      hover: 'var(--button-success-color)'
    }
  },

  text: {
    background: {
      _: 'transparent !important',
      active: 'var(--color-gray-400)',
      hover: 'var(--color-gray-300)'
    },
    border: {
      _: 'transparent !important',
      active: 'var(--color-gray-400)',
      hover: 'var(--color-gray-300)'
    },
    color: {
      _: 'var(--color-text)',
      active: 'var(--button-text-color)',
      hover: 'var(--button-text-color)'
    }
  }
};
